import { render, staticRenderFns } from "./CategoryInstructions.vue?vue&type=template&id=b1f07ee4&"
import script from "./CategoryInstructions.vue?vue&type=script&lang=js&"
export * from "./CategoryInstructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports